// Axion Elite — Footer interactions
// Magnetic hover pull (nav/social/back-to-top links), a cursor-reactive
// spotlight on the giant wordmark (same --x/--y technique as
// chroma-grid.js), a live local-time readout, and back-to-top scroll.
// Magnetic pull + wordmark spotlight require a fine pointer and are fully
// skipped (no listeners attached) under prefers-reduced-motion or on
// coarse/touch pointers, mirroring axion-microinteractions.js.

(function () {
  var MAGNETIC_STRENGTH = 0.35;
  var MAGNETIC_MAX_OFFSET = 16; // px — keeps the pull subtle/precise, not rubbery
  var SPOTLIGHT_DAMPING = 0.4;
  var SPOTLIGHT_EASE = 'power3.out';

  // Transition itself (duration/easing) is owned by CSS on each element's
  // own selector (combined with its existing color/border transitions —
  // see .site-footer__nav a, .site-footer__social a, .footer-back-to-top
  // in axion-components.css). JS only ever writes the one genuinely
  // dynamic value, the per-frame transform offset, per CLAUDE.md's inline
  // style rule.
  function initMagnetic() {
    var els = document.querySelectorAll('.axion-magnetic');
    if (!els.length) return;

    els.forEach(function (el) {
      function reset() {
        el.style.transform = '';
      }

      el.addEventListener('pointermove', function (e) {
        var rect = el.getBoundingClientRect();
        var relX = e.clientX - (rect.left + rect.width / 2);
        var relY = e.clientY - (rect.top + rect.height / 2);
        var x = Math.max(-MAGNETIC_MAX_OFFSET, Math.min(MAGNETIC_MAX_OFFSET, relX * MAGNETIC_STRENGTH));
        var y = Math.max(-MAGNETIC_MAX_OFFSET, Math.min(MAGNETIC_MAX_OFFSET, relY * MAGNETIC_STRENGTH));
        el.style.transform = 'translate(' + x.toFixed(2) + 'px,' + y.toFixed(2) + 'px)';
      });

      // pointerleave alone can miss a reset on devices that mix touch with
      // a fine pointer (touch doesn't reliably fire enter/leave) — pointerup
      // and pointercancel cover that so the link never gets stuck offset.
      el.addEventListener('pointerleave', reset);
      el.addEventListener('pointerup', reset);
      el.addEventListener('pointercancel', reset);
    });
  }

  function initWordmarkSpotlight() {
    var el = document.getElementById('axion-footer-wordmark');
    if (!el) return;
    if (typeof gsap === 'undefined') return;

    var setX = gsap.quickSetter(el, '--x', 'px');
    var setY = gsap.quickSetter(el, '--y', 'px');
    var rect = el.getBoundingClientRect();
    var pos = { x: rect.width / 2, y: rect.height / 2 };
    setX(pos.x);
    setY(pos.y);

    el.addEventListener('pointermove', function (e) {
      var r = el.getBoundingClientRect();
      gsap.to(pos, {
        x: e.clientX - r.left,
        y: e.clientY - r.top,
        duration: SPOTLIGHT_DAMPING,
        ease: SPOTLIGHT_EASE,
        onUpdate: function () {
          setX(pos.x);
          setY(pos.y);
        },
        overwrite: true
      });
    });
  }

  function initClock() {
    var el = document.getElementById('axion-footer-clock');
    if (!el) return;

    function pad(n) {
      return n < 10 ? '0' + n : String(n);
    }

    function tick() {
      var now = new Date();
      el.textContent = pad(now.getHours()) + ':' + pad(now.getMinutes()) + ':' + pad(now.getSeconds());
    }

    tick();
    setInterval(tick, 1000);
  }

  function initBackToTop() {
    var btn = document.getElementById('axion-footer-top');
    if (!btn) return;

    btn.addEventListener('click', function () {
      var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top: 0, behavior: reduced ? 'auto' : 'smooth' });
    });
  }

  function init() {
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var fine = window.matchMedia('(pointer: fine)').matches;

    if (!reduced && fine) {
      initMagnetic();
      initWordmarkSpotlight();
    }

    initClock();
    initBackToTop();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
